import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token')||'', //用户校验
		userInfo:localStorage.getItem('userInfo')?JSON.parse(localStorage.getItem('userInfo')):{},
    userInfos:localStorage.getItem('userInfos')?JSON.parse(sessionStorage.getItem('userInfos')):{},
		userId:'',
  },
  mutations: {
    changeUserId(state, data) {
			try {
				localStorage.setItem('userId', data)
			} catch (error) {}
			state.userId = data
		},
		changeToken(state, data) {
			try {
				localStorage.setItem('token', data)
			} catch (error) {}
			state.token = data
		},
    USER_INFOS(state, data) {
			try {
				sessionStorage.setItem('userInfos', data)
			} catch (error) {}
			state.userInfos = data
		},
		USER_INFO(state, data) {
			try {
				localStorage.setItem('userInfo', data)
			} catch (error) {}
			state.userInfo = data
		},
    changeNationality(state,data){
      state.nationality = data
    },
    changeTitBar(state,data){
      state.titBar = data
    },
    changeCurrent(state,data){
      state.current = data
    }
  },
  actions: {
    updateUserInfos({ commit }, newData) {
      commit('USER_INFOS', newData);
    },
    updateUserInfo({ commit }, newData) {
      commit('USER_INFO', newData);
    },
    updateToken({ commit }, newData) {
      commit('changeToken', newData);
    },
  },
  modules: {
  }
})
